(function () {
    'use strict';

    angular
        .module('aricControllers')
        .controller('AricCertificationController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'activeProcess'];

    function Controller($scope, $state, topBarService, activeProcess) {
		topBarService.setTitleAndIcon('Certification', 'fa fa-eye');

        // Accessed by child controller
        $scope.activeProcess = activeProcess;

        if (!_.isObject(activeProcess) || _.isUndefined(activeProcess.GovernanceProcessID)) {
            $state.go('aricCertification.noActiveProcess', {}, { location: 'replace' });
            return;
        }
    }
})();